<template>
    <div>
        <b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patient.afa.lblRestingHR") }}
                        <eventi-storico-misure-component misura="hr1" misuraLabel="Hr1" unitaMisura="" :idPaziente="idPaziente" :tipoEvento="tipoEvento" :gruppo="gruppo"></eventi-storico-misure-component>
                    </label>
                    <span class="sa-data">{{ jsonData.hr1 }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patient.afa.lblAfterStressHR") }}
                        <eventi-storico-misure-component misura="hr2" misuraLabel="Hr2" unitaMisura="" :idPaziente="idPaziente" :tipoEvento="tipoEvento" :gruppo="gruppo"></eventi-storico-misure-component>
                    </label>
                    <span class="sa-data">{{ jsonData.hr2 }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patient.afa.lblRestingPR") }}
                        <eventi-storico-misure-component misura="pr1" misuraLabel="Pr1" unitaMisura="" :idPaziente="idPaziente" :tipoEvento="tipoEvento" :gruppo="gruppo"></eventi-storico-misure-component>
                    </label>

                    <span class="sa-data">{{ jsonData.pr1 }}</span>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patient.afa.lblAfterStressPR") }}
                        <eventi-storico-misure-component misura="pr2" misuraLabel="Pr2" unitaMisura="" :idPaziente="idPaziente" :tipoEvento="tipoEvento" :gruppo="gruppo"></eventi-storico-misure-component>
                    </label>
                    <span class="sa-data">{{ jsonData.pr2 }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patient.afa.lblRestingQT") }}
                        <eventi-storico-misure-component misura="qt1" misuraLabel="Qt1" unitaMisura="" :idPaziente="idPaziente" :tipoEvento="tipoEvento" :gruppo="gruppo"></eventi-storico-misure-component>
                    </label>
                    <span class="sa-data">{{ jsonData.qt1 }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patient.afa.lblAfterStressQT") }}
                        <eventi-storico-misure-component misura="qt2" misuraLabel="Qt2" unitaMisura="" :idPaziente="idPaziente" :tipoEvento="tipoEvento" :gruppo="gruppo"></eventi-storico-misure-component>
                    </label>

                    <span class="sa-data">{{ jsonData.qt2 }}</span>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patient.afa.lblRestingQTC") }}
                        <eventi-storico-misure-component misura="qtc_riposo" misuraLabel="Qtc Riposo" unitaMisura="" :idPaziente="idPaziente" :tipoEvento="tipoEvento" :gruppo="gruppo"></eventi-storico-misure-component>
                    </label>
                    <span class="sa-data">{{ jsonData.qtcRiposo }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patient.afa.lblPulsation") }}
                        <eventi-storico-misure-component misura="hr_3" misuraLabel="hr3" unitaMisura="" :idPaziente="idPaziente" :tipoEvento="tipoEvento" :gruppo="gruppo"></eventi-storico-misure-component>
                    </label>
                    <span class="sa-data">{{ jsonData.hr3 }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patient.afa.lblIri") }}
                        <eventi-storico-misure-component misura="iri" misuraLabel="iri" unitaMisura="" :idPaziente="idPaziente" :tipoEvento="tipoEvento" :gruppo="gruppo"></eventi-storico-misure-component>
                    </label>
                    <span class="sa-data">{{ jsonData.iri }}</span>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                    <label class="sa-label-data">{{ this.$i18n.t("patient.afa.lblIriJudgement") }}</label>
                    <span class="sa-data">{{ jsonData.giudizioIri }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                    <label class="sa-label-data">{{ this.$i18n.t("patient.afa.lblReport") }}</label>
                    <span class="sa-data">{{ jsonData.referto }}</span>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Stato</label>
                    <span class="sa-data">{{ jsonData.firmaEcg }}</span>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import EventiStoricoMisureComponent from "../../../base/components/EventiStoricoMisureComponent.vue";
export default {
    components: { EventiStoricoMisureComponent },
    props: {
        jsonData: {
            Type: Object,
            require: true,
        },
        gruppo: {
            Type: String,
            require: true,
        },
        tipoEvento: {
            Type: String,
            require: true,
        },
    },
    computed: {
        idPaziente() {
            let me = this;
            return me.jsonData.idPaziente;
        },
    },
    data() {
        return {};
    },
};
</script>
